import { Example } from './helpers/model';
import { Dropdown, XIIcon } from '@inmoment/the-kitchen';

// name the export <ReactComponentName_examples>
export const Dropdown_examples: Example<Parameters<typeof Dropdown>[0]>[] = [
  {
    name: 'Formatted tooltip for disabled Dropdown',
    props: (framework) => ({
      disabled: true,
      data: [{ id: '0', title: 'The selected item has a really really really really really really long title.' }],
      value: '0',
      tooltip: {
        text:
          framework === 'react' ? (
            <>
              <XIIcon icon="password_filled" style={{ display: 'inline-block', verticalAlign: 'middle' }} />
              <span style={{ verticalAlign: 'middle' }}>
                <b style={{ color: 'red' }}>Tooltip!</b>
              </span>
            </>
          ) : (
            `<xi-icon icon="password_filled" style="display: inline-block; vertical-align: middle;" ></xi-icon> 
<span style="vertical-align: middle;">
  <b style="color: red;">Tooltip!</b>
  Angular template syntax isn't allowed here. Angular template syntax isn't allowed here. Angular template syntax isn't allowed here.
</span>`
          ),
      },
    }),
    // Manually add examples to have better formatting of the HTML/JSX
    react: `<Dropdown 
  disabled
  data={[{ id: '0', title: 'The selected item has a really really really really really really long title.' }]}
  value="0"
  tooltip={{
    text: (
      <>
        <XIIcon icon="password_filled" style={{ display: 'inline-block', verticalAlign: 'middle' }} />
        <span style={{ verticalAlign: 'middle' }}>
          <b style={{ color: 'red' }}>Tooltip!</b>
        </span>
      </>
    )
  }}
  />`,
    // use tooltip="{{ ... }}" here because Angular won't accept the [tooltip]="" form
    angular: `<xi-dropdown
  [disabled]="true"
  [data]="[{ id: '0', title: 'The selected item has a really really really really really really long title.' }]"
  value="0"
  tooltip="{{ 
    {
      text: '
        <xi-icon icon=\\'password_filled\\' style=\\'display: inline-block; vertical-align: middle;\\' ></xi-icon> 
        <span style=\\'vertical-align: middle;\\'>
          <b style=\\'color: red;\\'>Tooltip!</b>
          Angular template syntax isn't allowed here.
          Angular template syntax isn't allowed here.
          Angular template syntax isn't allowed here.
        </span>
      '
    } 
  }}">
</xi-dropdown>`,
    releaseVersion: '15.5.0',
  },
];
